import { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import { removeHtmlTags } from '../../Utilities/Utilities';
import { setRenderFormData } from '../../redux/slices/Notes/counsellingNoteSlice';
import { useDispatch, useSelector } from 'react-redux';
import setUiMessage from '../../Utilities/Tostify';

function ConsultationMigrationPopup({
  handleClose,
  patientId,
  soapId,
  appId,
  visitId,
  handleReload,
}) {
  const [allData, setAllData] = useState(false);
  const [textAreaData, setTextAreaDataData] = useState({});

  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/patient/progressNote/openConsultationPopup',
          {
            patientId: patientId,
            soapId: soapId,
            appId: appId,
            visitId: visitId,
          }
        );
        if (response.status === 200) {
          setAllData(response?.data);
          const formDatas = response?.data?.therapyMasterData?.reduce(
            (acc, data) => {
              data[2]?.forEach((subData) => {
                const key = `consultDetailsText_${data[3]}_${subData[0]}`;
                acc[key] = subData[3];
              });
              return acc;
            },
            {}
          );
          setTextAreaDataData(formDatas);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [patientId, soapId, appId, visitId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTextAreaDataData({ ...textAreaData, [name]: value });
  };

  const handleCounsellingFormSave = async () => {
    try {
      const response = await post(
        'api/patient/progressNote/saveConsultationForm',
        {
          patientId: patientId,
          soapId: soapId,
          appId: appId,
          visitId: visitId,
          staffUserId: user?.id,
          consultationDataJson: getTherapyJson(),
        }
      );
      if (response.status === 200) {
        handleClose();
        handleReload('consultation');

        dispatch(
          setRenderFormData({
            data: {
              consultationData: response.data.renderConsultationData,
            },
            type: 'consultation',
          })
        );
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleCounsellingFormUpdate = async () => {
    try {
      const response = await post(
        'api/patient/progressNote/updateConsultationForm',
        {
          patientId: patientId,
          soapId: soapId,
          appId: appId,
          staffUserId: user?.id,
          consultationDataJson: getTherapyJson(),
        }
      );
      if (response.status === 200) {
        handleClose();
        handleReload('consultation');
        dispatch(
          setRenderFormData({
            data: {
              consultationData: response.data.renderConsultationData,
            },
            type: 'consultation',
          })
        );
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const getTherapyJson = () => {
    let masterArr = [];
    let childArr = [];
    let masterId = '';

    allData?.therapyMasterData?.map((data, i) =>
      data[2]?.map((subData, j) => (masterId = data[3] + '_' + subData[0]))
    );

    let masterText = document.querySelector(
      '#consultDetailsText_' + masterId
    ).value;

    //let masterText = textareaRef.current.value;
    let retStr = false;

    masterArr.push({
      masterId: masterId,
      masterText: masterText,
      childArr: childArr,
    });
    retStr = JSON.stringify(masterArr);
    return retStr;
  };

  const handleCloseFun = (type) => {
    if (type === 'silent') {
      handleClose();
      return;
    }
    if (allData.mode === 'add') {
      handleCounsellingFormSave();
    } else if (allData.mode === 'edit') {
      handleCounsellingFormUpdate();
    }
  };

  return (
    <div className="modalBackground">
      <div
        className="pie-note-blk subsequent-counseling thrnst-nw-cnslng"
        style={{ height: '567px' }}
      >
        <div className="asmnt-prnt-blk-hdr">
          <span className="left clear5">Note:</span>
          <span className="right bold cursor" onClick={handleCloseFun}>
            X
          </span>
        </div>

        <div className="asmnt-prnt-blk-bdy" style={{ height: '500px' }}>
          <div
            className="asmnt-childblk childblk2 blk2-col3 overflow noteDivArea"
            style={{ width: '99% !important' }}
          >
            <div className="asmnt-ptnt-demo " style={{ paddingTop: '0px' }}>
              <div className="left asmnt-ptnt-demo-rw">
                {allData?.therapyMasterData?.map((data, i) => (
                  <>
                    {data[2]?.map((subData, j) => (
                      <textarea
                        className="cmntp-medication"
                        placeholder="Write here..."
                        id={'consultDetailsText_' + data[3] + '_' + subData[0]}
                        name={
                          'consultDetailsText_' + data[3] + '_' + subData[0]
                        }
                        spellCheck="true"
                        value={removeHtmlTags(
                          textAreaData &&
                            textAreaData[
                              'consultDetailsText_' + data[3] + '_' + subData[0]
                            ]
                        )}
                        onChange={handleInputChange}
                      ></textarea>
                    ))}
                  </>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="asmnt-prnt-blk-ftr">
          {(allData.mode === 'add' && (
            <button className="actn-yes" onClick={handleCounsellingFormSave}>
              Save
            </button>
          )) ||
            (allData.mode === 'edit' && (
              <button
                className="actn-yes"
                onClick={handleCounsellingFormUpdate}
              >
                Update
              </button>
            ))}
          <button className="actn-No" onClick={handleCloseFun}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConsultationMigrationPopup;
